/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import Grid from "@mui/material/Grid";
import summaryStyle from "../summaryStyle";
import Typography from "@mui/material/Typography";
import { dayjsToGermanDate } from "../../../../services/formatService";
import { Box } from "@mui/material";

type PersonalDataSummaryProps = {
  formData: Record<string, any>;
};
const PersonalDataSummary = ({ formData }: PersonalDataSummaryProps) => {
  return (
    <>
      <Grid sx={summaryStyle.subHeadline} size={12}>
        <Typography variant={"h5"}>Persönliche Angaben</Typography>
      </Grid>
      <Grid sx={summaryStyle.question} size={12}>
        <Box id={"insurer"} sx={summaryStyle.scrollToAnchor} />
        Rechtsschutzversicherung
      </Grid>
      <Grid size={12}>
        {formData.isCostCovered === "yes" ? "Kosten werden mit " + formData.costCoverageAmount + " € übernommen" : "Kosten werden nicht übernommen"}
        <br />
        {formData.hasPotentialCoverage === "yes" ? "Kosten könnten ggf. übernommen werden von: " + formData.potentialCoverer : "Keine Kostenübernahme möglich"}
        <br />
      </Grid>
      <Grid sx={summaryStyle.question} size={12}>
        <Box id={"nameAdress"} sx={summaryStyle.scrollToAnchor} />
        Name und Adresse
      </Grid>
      <Grid size={12}>
        {formData.petitioner.gender === "male" ? "Herr" : "Frau"} {formData.petitioner.givenName} {formData.petitioner.familyName}
        {formData.petitioner.birthName != null && " (geb. " + formData.petitioner.birthName + ")"}
        <br />
        Geburtsdatum: {dayjsToGermanDate(formData.petitioner.birthDate)}
        <br />
        {formData.petitioner.addresses[0].streetAddress}
        <br />
        {formData.petitioner.addresses[0].postalCode} {formData.petitioner.addresses[0].addressLocality}
        <br />
        Tel: {formData.telephone}
        <br />
      </Grid>
      <Grid sx={summaryStyle.question} size={12}>
        <Box id={"job"} sx={summaryStyle.scrollToAnchor} />
        Beruf
      </Grid>
      <Grid size={12}>
        {formData.job}
      </Grid>
      <Grid sx={summaryStyle.question} size={12}>
        <Box id={"legalRepresentative"} sx={summaryStyle.scrollToAnchor} />
        Gesetzlicher Vertreter
      </Grid>
      <Grid size={12}>
        {formData.hasLegalRepresentative === "no" ? (
          "Kein gesetzlicher Vertreter"
        ) : (
          <>
            {formData.legalRepresentative.gender === "male" ? "Herr" : "Frau"} {formData.legalRepresentative.givenName}{" "}
            {formData.legalRepresentative.familyName}
            <br />
            {formData.legalRepresentative.addresses[0].streetAddress}
            <br />
            {formData.legalRepresentative.addresses[0].postalCode} {formData.legalRepresentative.addresses[0].addressLocality}
            <br />
            Tel: {formData.telephoneRepresentative}
            <br />
          </>
        )}
      </Grid>
      <Grid sx={summaryStyle.question} size={12}>
        <Box id={"alimonyClaims"} sx={summaryStyle.scrollToAnchor} />
        Unterhaltsanspruch
      </Grid>
      <Grid size={12}>
        {formData.hasAlimonyClaims === "no" ? (
          "Kein Unterhaltsanspruch"
        ) : (
          <>
            Unterhaltsverpflichtet ist:
            <br />
            {formData.alimonyObligatedPerson.gender === "male" ? "Herr" : "Frau"} {formData.alimonyObligatedPerson.givenName}{" "}
            {formData.alimonyObligatedPerson.familyName}
            <br />
            Verhältnis: {formData.alimonyObligatedPersonRelation}
            <br />
          </>
        )}
      </Grid>
      <Grid sx={summaryStyle.question} size={12}>
        <Box id={"relativesAlimonyClaims"} sx={summaryStyle.scrollToAnchor} />
        Unterhaltsverpflichtungen
      </Grid>
      <Grid size={12}>
        {formData.hasRelativesAlimonyClaims === "no" ? (
          "Keine Unterhaltsverpflichtungen"
        ) : (
          <>
            Unterhaltsverpflichtet gegenüber:
            {formData.alimonyPersons?.map((alimonyPerson: Record<string, any>, key: number) => (
              <React.Fragment key={key}>
                <br />
                <br />
                {alimonyPerson.givenName} {alimonyPerson.familyName} ({alimonyPerson.relation})<br />
                {alimonyPerson.livesWithPetitioner ? (
                  <>Wohnt bei mir</>
                ) : (
                  <>
                    {alimonyPerson.address.streetAddress}, {alimonyPerson.address.postalCode} {alimonyPerson.address.addressLocality}
                  </>
                )}
                <br />
                geboren am {alimonyPerson.birthDate}
                <br />
                Geleisteter Unterhalt: {alimonyPerson.alimony === "0" ? "Naturalunterhalt" : alimonyPerson.alimony + " €"}
                <br />
                {alimonyPerson.hasIncome === "no" ? "Hat kein eigenes Einkommen" : "Einkommen: " + alimonyPerson.income + " €"}
              </React.Fragment>
            ))}
          </>
        )}
      </Grid>
    </>
  );
};

export default PersonalDataSummary;
